<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableAppServiceResourceAzureDate"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableAppServiceResourceAzureVue = {};
export default {
  name: "TableAppServiceResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      name: "",
      accountName: "",
      resourceGroup: "",
      columns: [
        {
          title: this.$t("RAM.Azure.appService.AccountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.appService.AccountID"),
          key: "accountId"
        },
        {
          title: this.$t("RAM.Azure.appService.SubscriptionName"),
          key: "subscriptionName"
        },
        {
          title: this.$t("RAM.Azure.appService.SubscriptionID"),
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.appService.ResourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("RAM.Azure.appService.Name"),
          key: "name"
        },
        {
          title: this.$t("RAM.Azure.appService.Area"),
          key: "region"
        },
        {
          title: this.$t("RAM.Azure.appService.Status"),
          key: "state"
        },
        {
          title: this.$t("RAM.Azure.appService.Type"),
          key: "type"
        },
        {
          title: this.$t("RAM.Azure.appService.ServerFarm"),
          key: "serverFarm"
        }
      ],
      tableAppServiceResourceAzureDate: []
    };
  },
  beforeCreate: function() {
    tableAppServiceResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("name", function(name) {
      tableAppServiceResourceAzureVue.name = name;
    });
    eventBus.$on("accountName", function(accountName) {
      tableAppServiceResourceAzureVue.accountName = accountName;
    });
    eventBus.$on("resourceGroup", function(resourceGroup) {
      tableAppServiceResourceAzureVue.resourceGroup = resourceGroup;
    });
    eventBus.$on("companyId", function(val) {
      tableAppServiceResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableAppServiceResourceAzureVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      this.$api.resourceManagement
        .queryPagingAzureWebAppConfig({
          name: tableAppServiceResourceAzureVue.name,
          accountName: tableAppServiceResourceAzureVue.accountName,
          resourceGroup: tableAppServiceResourceAzureVue.resourceGroup,
          companyId: tableAppServiceResourceAzureVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableAppServiceResourceAzureDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAppServiceResourceAzureVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAppServiceResourceAzureVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("name");
      eventBus.$off("accountName");
      eventBus.$off("resourceGroup");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/app_service/TableAppServiceResourceAzure.vue